import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getMouListApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}mou/`+params,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })
    return response

}

export default getMouListApi